export function createActions() {
  return {
    setFiatAmount: (payload) => ({ type: 'SET_FIAT_AMOUNT', payload }),
    setIsEmptyFromAmount: (payload) => ({ type: 'SET_IS_EMPTY_FROM_AMOUNT', payload }),
  }
}

const actionsDefinition = {
  factory: createActions,
  dependencies: [],
}

export default actionsDefinition
